const initialTaluka = {
    talukaPermissions:{},
    talukaLists: [],
    talukaStatus: [],
    changedTalukaStatus : [],
    loadingTaluka: false,
    errorsTaluka: {}
}

const  talukaReducer = (state = initialTaluka, action) => {
    switch (action.type) {
        case "GET_TALUKALIST_PENDING":
        case "ADD_TALUKA_PENDING":
        case "UPDATE_TALUKA_PENDING":
        case "UPDATE_TALUKA_STATUS_PENDING":
        case "DELETE_TALUKA_PENDING":
        case "GET_TALUKALISTBYID_PENDING":
            return { ...state, loadingTaluka: true };

        case "GET_TALUKALIST_FULFILLED":
            return {
                ...state,
                loadingTaluka: false,
                talukaLists: action.payload,
                talukaCount: action.talukaCount,
                talukaPermissions:action.permissions,
            };

        case "ADD_TALUKA_FULFILLED":
            return {
                ...state,
                loadingTaluka: false,
                changedTalukaStatus: action.payload,
            };

        case "UPDATE_TALUKA_FULFILLED":
            return {
                ...state,
                loadingTaluka: false,
                changedTalukaStatus: action.payload,
            };

        case "UPDATE_TALUKA_STATUS_FULFILLED":
                return {
                    ...state,
                    loadingTaluka: false,
                    changedTalukaStatus: action.payload,
                };

        case "GET_TALUKALISTBYID_FULFILLED":
            return {
                ...state,
                loadingTaluka: false,
                talukaLists: action.payload
            };

        case "DELETE_TALUKA_FULFILLED":
            return {
                ...state,
                loadingTaluka: false,
                changedTalukaStatus: action.payload
            };

        case "RESET_DELETE_TALUKA_STATUS":
            return {
                ...state,
                loadingTaluka: false,
                changedTalukaStatus: [],
                errorsTaluka:{}
            };

        case "GET_TALUKALIST_REJECTED":
        case "ADD_TALUKA_REJECTED":
        case "UPDATE_TALUKA_REJECTED":
        case "UPDATE_TALUKA_STATUS_REJECTED":
        case "DELETE_TALUKA_REJECTED":
        case "GET_TALUKALISTBYID_REJECTED":
            return {
                ...state,
                loadingTaluka: false,
                errorsTaluka: action.payload
            };

        default:
            return state;
    }
}

export default talukaReducer;